export default {
    resend_invite_title: "Resend invite",
    resend_invite_message: "Do you want to resend the invitation?",
    resend_invite_success_message: "The invitation has been resent",
    resend_invite_error_message: "Unable to resend the invitation due to an error",
    resend_invite_new_password: "New Password",
};